import type { PageThemeDefinition } from "../types";

export const oceanTheme: PageThemeDefinition = {
  id: "ocean",
  labelKey: "robot.setting.page_theme.ocean",
  preview: {
    background: "#0A1628",
    cardBg: "#0F1F35",
    text: "#ffffff",
  },
  tokens: {
    background: "#0A1628",
    cardBg: "#0F1F35",
    text: "#ffffff",
    textSecondary: "#A8C4DC",
    border: "#1A3A5C",
    headerBg: "#0A1628",
    inputBg: "#0F1F35",
    messageBg: "#0F1F35",
    senderBg: "#0F1F35",
    statusOnline: "#02BA54",
    statusEnding: "#ED645F",
    starActive: "#FFE200",
    starInactive: "#3a5570",
    shadow: "rgba(0, 0, 0, 0.5)",
    hoverBg: "#142840",
    accent: "#00B4D8",
    appearance: "dark",
    chatMessageText: "#FFFFFF",
    chatAgentBubbleBg: "#172C48",
    chatAgentBubbleBorder: "#25466B",
    chatUserGradientStart: "#0077B6",
    chatUserGradientEnd: "#023E8A",
    chatUserMessageText: "#FFFFFF",
    chatInputFieldBg: "#0A1628",
    chatInputText: "#FFFFFF",
    chatInputPlaceholder: "#A8C4DC",
    chatMediaBg: "#0A1628",
    chatIconColor: "#FFFFFF",
    chatLinkColor: "#48CAE4",
  },
};
